import {create} from 'zustand';
import {AuthorizationsStore} from './types';

export const useAuthorizationsStore = create<AuthorizationsStore>((set, get) => ({
	nuControle: '',
	businessHours: false,
	attachSentNotification: false,
	providersList: [],
	cdUf: '',
	hasProviderPreference: false,
	providerObservation: '',

	setNuControle: nuControle => set({nuControle}),
	setBusinessHours: businessHours => set({businessHours}),
	setAttachSentNotification: attachSentNotification => set({attachSentNotification}),
	setProvidersList: providersList => set({providersList}),
	setCdUf: cdUf => set({cdUf}),
	setHasProviderPreference: hasProviderPreference => set({hasProviderPreference}),
	setProviderObservation: providerObservation => set({providerObservation}),

	removeProviderById: (uniqueId: string) => {
		const currentList = get().providersList;
		const filteredList = currentList.filter(provider => provider?.idUnico !== uniqueId);
		set({providersList: filteredList});
	},

	resetProvidersList: () => set({providersList: []}),
}));
